<div #rootelement class="dgoods-price-option" (click)="onToggle()">
    <span #amount (click)="onClickOnAmount($event)">{{ currency }} {{ value | number: '2.2-2' }}</span>
</div>
<div *ngIf="price.isDenomination" #description class="description">
    Min. {{ price.minValue | number: '2.0-0' }} / Max. {{ price.maxValue | number: '2.0-0' }}
</div>
